import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { buttonsStyle, dateFormatter, substringFormatter } from '../../../components/tables/table'
import { getFAQs, deleteFAQ } from '../../../../api/faq'
import { Button, Tooltip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import { getNonEmpty } from '../../../../utils/helpers'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'

function getData(faqs) {
  let data = []
  for (let i = 0; i < faqs.length; ++i) {
      const elem = {}
      elem.question = getNonEmpty(faqs[i].question)
      elem.answer = getNonEmpty(faqs[i].answer)
      elem.order = faqs[i].order || 0
      elem.createdAt = faqs[i].createdAt
      elem.id = faqs[i]._id
      data = data.concat(elem)
  }
  return data
}

export default function FAQsPage() {
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [faqToDelete, setFaqToDelete] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    return (<>
      <Tooltip title="Edit">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-faq/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
      <Tooltip title="Delete">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setFaqToDelete(cell)
            setOpenConfirmDialog(true)
          }}>
          <DeleteIcon/>
        </Button>
      </Tooltip>
    </>)
  }

  const columns = [
    { dataField: 'order', text: 'Order', sort: true },
    { dataField: 'question', text: 'Question', sort: true, formatter: substringFormatter },
    { dataField: 'answer', text: 'Answer', sort: true, formatter: substringFormatter },
    {
			dataField: 'createdAt',
			text: 'Created at',
			formatter: dateFormatter,
			sort: true,
		},
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getFAQs().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get FAQs.' })
    })
  }, [refresh])

  const handleDelete = () => {
    if (!faqToDelete) return
    
    deleteFAQ(faqToDelete).then((res) => {
      if (res.status === 200 || res.status === 204) {
        alertSuccess({
          title: 'Deleted!',
          customMessage: 'FAQ removed successfully.'
        })
        setRefresh(true)
        setOpenConfirmDialog(false)
        setFaqToDelete(null)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not delete FAQ.' })
    })
  }

  return (
    <>
      <Card>
        <CardHeader title='FAQs list'>
          <CardHeaderToolbar>
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push('/edit-faq')}
            >
              Add FAQ
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title="Are you sure you want to remove this FAQ?"
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={handleDelete}
          />
        </CardBody>
      </Card>
    </>
  );
}

